<template>
    <label class="app-switch" :class="{'disabled': disabled}">
        <input
            type="checkbox"
            class="form-check-input-switchery"
            :disabled="disabled"
            :checked="modelValue"
            @change="$emit('update:modelValue', !modelValue)"
        >
        <span class="switchery" :class="{'switchery-checked': modelValue}">
            <small></small>
        </span>
        <span class="app-switch-label" v-if="$slots.default"><slot></slot></span>
    </label>
</template>
<script>
export default {
    name: 'AppSwitch',
    props: {
        modelValue: {
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue']
}
</script>
<style scoped>
.app-switch {
    display: flex;
    align-items: center;
    width: fit-content;
    margin-bottom: 0;
    cursor: pointer;
}

.app-switch.disabled {
    cursor: default;
    opacity: 0.6;
}

.app-switch > .form-check-input-switchery {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
}

.app-switch > .switchery {
    flex-shrink: 0;
    transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;
}

.app-switch > .switchery > small {
    left: 0;
    transition: background-color 0.4s, left 0.2s;
}

.app-switch > .switchery-checked {
    background-color: #64bd63;
    border-color: #64bd63;
    box-shadow: #64bd63 0 0 0 10px inset;
}

.app-switch > .switchery-checked > small {
    left: 1.125rem;
}

.app-switch-label {
    margin-left: 0.625rem;
}
</style>
